module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-cyrillic2.5a54677.woff2";